export const ORGANIZATIONS_QUERY_KEY = 'organizations';
export const ORGANIZATION_TRAINERS_QUERY_KEY = 'organizationTrainers';
export const ORGANIZATION_TRAINERS_BY_DADESKTOP_QUERY_KEY = 'organizationTrainersByDaDesktopId';
export const ORGANIZATION_INVITATIONS_QUERY_KEY = 'organizationInvitations';
export const TRAINER_INVITATION_QUERY_KEY = 'trainerInvitation';
export const TRAINER_INVITATION_BY_TOKEN_QUERY_KEY = 'trainerInvitationByToken';
export const MY_PENDING_TRAINER_INVITATIONS_QUERY_KEY = 'myPendingTrainerInvitations';
export const ORGANIZATION_USERS_QUERY_KEY = 'organizationUsers';
export const ORGANIZATION_MEMBERSHIP_HISTORY_QUERY_KEY = 'organizationMembershipHistory';
export const MY_MANAGED_ORGANIZATIONS_QUERY_KEY = 'myManagedOrganizations';
export const MANAGED_ORGANIZATION_USERS_QUERY_KEY = 'managedOrganizationUsers';
export const SYSTEM_INVITATIONS_QUERY_KEY = 'systemInvitations';
